export default {
    name: 'Nimi',
    tel: 'Puhelin',
    save: 'Tallenna',
    confirm: 'Vahvista',
    cancel: 'Peruuta',
    delete: 'Poista',
    complete: 'Valmis',
    loading: 'Ladataan...',
    telEmpty: 'Syötä puhelinnumero',
    nameEmpty: 'Syötä nimi',
    nameInvalid: 'Virheellinen nimi',
    confirmDelete: 'Haluatko varmasti poistaa?',
    telInvalid: 'Virheellinen puhelinnumero',
    vanCalendar: {
        end: 'Loppu',
        start: 'Alku',
        title: 'Kalenteri',
        startEnd: 'Alku/Loppu',
        weekdays: ['Su', 'Ma', 'Ti', 'Ke', 'To', 'Pe', 'La'],
        monthTitle: (year, month) => `${year}/${month}`,
        rangePrompt: (maxRange) => `Valitse enintään ${maxRange} päivää`,
    },
    vanCascader: {
        select: 'Valitse',
    },
    vanContactCard: {
        addText: 'Lisää yhteystiedot',
    },
    vanContactList: {
        addText: 'Lisää uusi kontakti',
    },
    vanPagination: {
        prev: 'Edellinen',
        next: 'Seuraava',
    },
    vanPullRefresh: {
        pulling: 'Vedä päivittääksesi...',
        loosing: 'Päivittääksesi...',
    },
    vanSubmitBar: {
        label: 'Yhteensä：',
    },
    vanCoupon: {
        unlimited: 'Rajoittamaton',
        discount: (discount) => `${discount * 10}% alennus`,
        condition: (condition) => `Vähintään ${condition}`,
    },
    vanCouponCell: {
        title: 'Kuponki',
        tips: 'Ei kuponkeja',
        count: (count) => `Sinulla on ${count} kuponkia`,
    },
    vanCouponList: {
        empty: 'Ei kuponkeja',
        exchange: 'Vaihda',
        close: 'Sulje',
        enable: 'Käytettävissä',
        disabled: 'Ei käytettävissä',
        placeholder: 'Kuponkikoodi',
    },
    vanAddressEdit: {
        area: 'Alue',
        postal: 'Postinumero',
        areaEmpty: 'Valitse vastaanottava alue',
        addressEmpty: 'Osoite ei voi olla tyhjä',
        postalEmpty: 'Virheellinen postinumero',
        defaultAddress: 'Aseta oletusosoitteeksi',
        telPlaceholder: 'Puhelin',
        namePlaceholder: 'Nimi',
        areaPlaceholder: 'Alue',
    },
    vanAddressEditDetail: {
        label: 'Osoite',
        placeholder: 'Osoite',
    },
    vanAddressList: {
        add: 'Lisää uusi osoite',
    },
};